// extracted by mini-css-extract-plugin
export default {"wrap":"OperatingPower_wrap__cW-KY","empty":"OperatingPower_empty__mvKVU"};